import React from 'react';

import ShowOnDesktop from 'brandComponents/Responsive/ShowOnDesktop';

import MobileApp from '../../../MobileApp';

import styles from './FooterMobileApp.module.scss';

const FooterMobileApp = () => {
	return (
		<ShowOnDesktop>
			<MobileApp classNames={styles.footer__app} store="apple" />
		</ShowOnDesktop>
	);
};

export default FooterMobileApp;
